const { mapState } = require("vuex");

const app = async () => {
  const { Vue: Vue } = await import(/* webpackChunkName: "vue" */ "../global");
    const { default: Vuex } = await import(/* webpackChunkName: "vue" */ "vuex");

    const { default: store } = await import(/* webpackChunkName: "store" */ "../store/store");
    const app = new Vue({
        name: "animate",
        el: "#animation-app",
        store,
        components: {
        },
        data: () => ({
        }),
        mounted() {
        },
      methods: {
          submit: function () {
          }


      },
  });
};

import gsap from "gsap";

/**
 * Create animation timelines
 *
 * @param {*} element
 * @returns
 */
const createAnimation = (element) => {
  const animations = element.querySelectorAll("[data-animate]");

  const timeline = gsap.timeline({
    paused: true,
    onComplete: () => {
      timeline.kill();
    },
  });

  animations.forEach((el) => {
    const from = JSON.parse(el.dataset.from);
    const positioning = el.dataset.positioning ? JSON.parse(el.dataset.positioning) : null;
    const duration = el.dataset.duration ? JSON.parse(el.dataset.duration) : 0.3;

    const options = {
      ...from,
      ...{
        ease: "power2",
        duration: duration,
      },
    };
    timeline.from(el, options, positioning);
  });
  const video = element.querySelector("video");
  if (video) {
    timeline.call(
      () => {
        video.currentTime = 0;
        video.play();
        video.onplay = () => {};
      },
      [],
      0
    );
  }

  return timeline;
};

/**
 * Initialise marketing page
 */
const initLandingPage = () => {
  const elements = document.querySelectorAll("[data-intersect]");
  const options = {
    rootMargin: "-30% 0%",
    threshold: 0,
  };

  const animations = [];
  let observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      const animation = animations.find((animation) => animation.element === entry.target);
      if (entry.isIntersecting) {
        if (animation) animation.timeline.play();
      } else {
        if (animation) animation.timeline.reverse();
      }
    });
  }, options);

  elements.forEach((element) => {
    observer.observe(element);
    animations.push({
      element: element,
      timeline: createAnimation(element),
    });
  });
};
import ScrollLink from "../utils/scroll-link";

app().then((vm) => {
  initLandingPage();

  new ScrollLink();
});
